import React from 'react'
import { VersionText } from './styles'
import { APP_VERSION } from '../../const/version'

export default function VersionIndicator () {
  return <VersionText>Retinar - v{APP_VERSION}</VersionText>
}
